import { cn } from "../../lib/utils";

const MAP = {
  CRITICAL: { label: "CRÍTICO", cls: "bg-red-500/10 border-red-500/30 text-red-400", dot: "bg-red-400" },
  HIGH: { label: "ALTO", cls: "bg-orange-500/10 border-orange-500/30 text-orange-400", dot: "bg-orange-400" },
  MEDIUM: { label: "MEDIO", cls: "bg-amber-500/10 border-amber-500/30 text-amber-300", dot: "bg-amber-300" },
  LOW: { label: "BAJO", cls: "bg-slate-500/10 border-slate-500/30 text-slate-300", dot: "bg-slate-300" },
  OPTIMIZED: { label: "ÓPTIMO", cls: "bg-emerald-500/10 border-emerald-500/30 text-emerald-400", dot: "bg-emerald-400" },
};

export function RiskBadge({ severity = "MEDIUM", showPulsingDot = false, className, ...props }) {
  const s = MAP[(severity || "MEDIUM").toUpperCase()] || MAP.MEDIUM;
  return (
    <span
      className={cn("inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 font-mono text-[0.65rem] font-medium tracking-widest", s.cls, className)}
      {...props}
    >
      {showPulsingDot && <span className={cn("h-1.5 w-1.5 rounded-full pulse-dot", s.dot)} />}
      {s.label}
    </span>
  );
}
